import React from "react";
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";

type Direction = "asc" | "desc";

const TopicTableColumnHeader: React.FunctionComponent<PropsWithRedux> = (props) => {
    interface HeaderCell {
        id: string;
        label: string;
        isSortable: boolean;
    }

    const getColumns = (): HeaderCell[] => [
        { id: "name", label: "Topic name", isSortable: true },
        { id: "kebab", label: "", isSortable: false },
        { id: "state", label: "State", isSortable: false },
        { id: "type", label: "Type", isSortable: false },
        { id: "subscribers", label: "Subscribers", isSortable: false },
        { id: "posts", label: "Posts", isSortable: false },
        { id: "events", label: "Events", isSortable: false },
        { id: "views", label: "Views", isSortable: false },
    ];

    const isFirstColumn = (hc: HeaderCell): boolean => hc.id === getColumns()[0].id;

    const getSortableLabel = (hc: HeaderCell): JSX.Element => {
        return (
            <TableSortLabel
                active={true}
                direction={props.direction}
                onClick={props.toggleDirection}
            >
                {hc.label}
            </TableSortLabel>
        );
    };

    const createColumnHeader = (hc: HeaderCell) : JSX.Element => {
        return (
            <TableCell
                key={hc.id}
                align={isFirstColumn(hc) ? "left" : "center"}
                padding={isFirstColumn(hc) ? "none" : "normal"}
            >
                {hc.isSortable ? getSortableLabel(hc) : hc.label}
            </TableCell>
        );
    };

    return (
        <React.Fragment>
            {
                getColumns().map((hc: HeaderCell) => createColumnHeader(hc))
            }
        </React.Fragment>
    );
};

interface ComponentProps {
    direction: Direction,
    toggleDirection: () => void;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
    }),
);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(TopicTableColumnHeader);